module.exports = __webpack_public_path__ + "static/media/ethernet.13b9a7f9.svg";